<script setup lang="ts">
import RoutingTrafficPage from '../features/routing-choices/RoutingTrafficPage.vue';
</script>

<template>
  <RoutingTrafficPage />
</template>
